// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import FormOptimizationController from "./form_optimization_controller"
application.register("form-optimization", FormOptimizationController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
